import React from "react";

// TS
import { message } from "./OpenAiWrapper";

import { useQueryClient } from "@tanstack/react-query";
import { UseGetTour } from "../../../api/calls/Queries";
import { useGptHistoryStore } from "../../../api/calls/OpenAi";

import { useWidePopupStore } from "../../../api/Zustand";

const Messages = (props: { isPending: boolean; tourID: number }) => {
  const { messageHistory } = useGptHistoryStore();

  const { data: tourData } = UseGetTour(props.tourID);

  const { setIsOpen, target } = useWidePopupStore();

  const queryClient = useQueryClient();

  const { resetHistory } = useGptHistoryStore();

  const setTextToPopup = React.useCallback(
    (text: string) => {
      queryClient.setQueryData(["GetTour", props.tourID], {
        ...tourData,
        popups: tourData?.popups.map((pop) =>
          pop.id === target ? { ...pop, text: text } : pop
        ),
      });
      setIsOpen(false, undefined);
      return resetHistory();
    },
    [props.tourID, tourData, queryClient, setIsOpen, target, resetHistory]
  );
  return (
    <div
      style={{
        flex: 1,
        position: "relative",
        // flexShrink: "1",
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          overflowY: "auto",
          position: "absolute",
        }}
      >
        {messageHistory.length === 0 && (
          <p
            style={{
              textAlign: "center",
              userSelect: "none",
              fontSize: "1.4rem",
              fontWeight: "700",
              opacity: 0.15,
            }}
          >
            Inizia una conversazione
          </p>
        )}

        {messageHistory.map((msg, index) => (
          <Message
            key={index}
            message={msg}
            fn={setTextToPopup}
            index={index}
            messageHistory={messageHistory}
          ></Message>
        ))}

        {props.isPending && (
          <Message
            message={loadingMessage}
            index={-1}
            messageHistory={messageHistory}
          />
        )}
      </div>
    </div>
  );
};

const loadingMessage: message = {
  content: "",
  role: "assistant",
  loading: true,
};

const Message = (props: {
  message: message;
  fn?: (text: string) => void;
  index: number;
  messageHistory: message[];
}) => {
  const fromApi = React.useMemo(() => {
    return props.message.role === "assistant";
  }, [props.message.role]);

  const isLast = props?.messageHistory?.length - 1 === props.index;

  const ref = React.useRef<HTMLDivElement>(null);

  const loadingRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isLast) {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [isLast]);

  React.useEffect(() => {
    if (loadingRef.current) {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [loadingRef]);

  return (
    <div
      ref={ref}
      style={{
        maxWidth: "100%",
        width: "max-content",
        minHeight: "80px",
        boxSizing: "border-box",
        padding: 5,
      }}
    >
      <b
        style={{
          textTransform: "capitalize",
          fontSize: "1rem",
          padding: 3,
          borderRadius: ".25rem",
          userSelect: "none",
          background: fromApi ? "#10a37f" : undefined,
          color: fromApi ? "white" : "#222",
        }}
      >
        {/* {props.message.role} */} {fromApi ? "Gpt 3.5" : "utente"}
      </b>
      <br />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        {!props.message.error && (
          <span
            style={{
              color: "#444",
              fontWeight: "500",
              padding: 0,
            }}
          >
            {props.message.content}
          </span>
        )}

        {props.message.loading && (
          <div ref={loadingRef} className="container">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        )}
        {props.message.error && (
          <span style={{ color: "red" }}>
            <b>
              {
                // @ts-expect-error
                props.message.error.response?.status
              }{" "}
              -{" "}
              {
                // @ts-expect-error
                props.message.error.response?.statusText
              }
            </b>
            <br></br>
            {
              // @ts-expect-error
              props.message.error.response?.data
            }
          </span>
        )}
        {fromApi && !props.message.loading && !props.message.error && (
          <button
            type="button"
            id="gpt-chat-button"
            title="Utilizza nel popup"
            onClick={() => {
              if (props.fn) props.fn(props.message.content);
            }}
          >
            {logo}
          </button>
        )}
      </div>

      {props.message.image && (
        <div style={{ marginTop: 10 }}>
          <img
            src={props.message.image}
            style={{ maxHeight: 300, maxWidth: 400 }}
            alt="Prompt generato da immagine"
          ></img>
        </div>
      )}
    </div>
  );
};

export default Messages;

const logo = (
  <svg
    transform="rotate(180)"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
  >
    <path d="M780-200v-156q0-60-39-99t-99-39H236l163 163-43 43-236-236 236-236 43 43-163 163h406q85 0 141.5 56.5T840-356v156h-60Z" />
  </svg>
);
